var _defs, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTickGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-tick",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-40 -35 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .icon-line--style2 {\n        fill: none;\n        stroke: #278450;\n        stroke-width: 9px;\n        stroke-linejoin: bevel;\n      }\n\n      .icon-line--miter-limit {\n        stroke-miterlimit: 10;\n      }\n\n      .icon-line--linecap {\n        stroke-linecap: round;\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "icon-line--style2 icon-line--miter-limit icon-line--linecap",
    points: "32.02 65.54 49.37 87.66 93.62 42.50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickGreen);
export default __webpack_public_path__ + "static/media/icon-tick-green.ae491511.svg";
export { ForwardRef as ReactComponent };